module.exports = __webpack_public_path__ + "img/vip-600.7a1c5a5f.png";